var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbExists)?_c('img',{staticClass:"course-name",attrs:{"src":_vm.thumbSrc}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }